export class GblJobtypemenuepermision {
    PermisionId : number;
    JobtypeId?: number;
    MenuId ?: number;
    ViewAllow ?:boolean;
    SaveAllow ?:boolean;
    UpdateAllow ?:boolean;
    DeleteAllow ?:boolean;    
    JobTypeName?: string;
    MenuName?: string;
    ParentMenuName?: string;
    OrgName?: string;
    SlNo?: number;
    IsActive?: boolean;
    OrgId?: number;
    CreatedBy?: number;
    CreatedOn?: Date;
    LastModifiedBy?: number;
    LastModifiedOn?: Date;
}
